<template>
    <div class="navs">
        <div class="marquee">
            <div class="marquee-content">
                {{ props.text }}
            </div>
        </div>
        <div class="right">
            <div class="cart relative" @click="$router.push({ name: 'cart' })">
                <i class="fa-solid fa-cart-shopping"></i>
                {{ $translate('components.info-bar.cart') }}
                <span
                    v-if="useCookieStore().getCartCount > 0"
                    class="nbr-count"
                >
                    {{ useCookieStore().getCartCount }}
                </span>
            </div>
            <div
                class="favoris relative"
                @click="$router.push({ name: 'favoris' })"
            >
                <i class="fa-solid fa-heart"></i>
                {{ $translate('components.info-bar.favoris') }}
                <span v-if="useCookieStore().getFavCount > 0" class="nbr-count">
                    {{ useCookieStore().getFavCount }}
                </span>
            </div>
            <div class="contact" @click="$router.push({ name: 'contact' })">
                <i class="fa-solid fa-envelope" style="color: #f5f5f5"></i>
                {{ $translate('components.info-bar.contact') }}
            </div>
            <div class="buttons">
                <primary-button
                    color="white"
                    v-if="!authStore.$state.isAuth"
                    @click="$router.push({ name: 'login' })"
                >
                    {{ $translate('components.info-bar.login') }}
                </primary-button>
                <primary-button
                    color="white"
                    v-else
                    @click="$router.push({ name: 'dashboard' })"
                    >{{
                        $translate('components.info-bar.dashboard')
                    }}</primary-button
                >
            </div>
        </div>
    </div>
</template>

<script setup>
import { useApiStore } from '@/js/stores/apiStore';
import { useAuthStore } from '@/js/stores/authStore';
import { useCookieStore } from '@/js/stores/cookiesStore';
import { useRouter } from 'vue-router';

const $router = useRouter();
const authStore = useAuthStore();
const apiStore = useApiStore();

await apiStore
    .call('get', '/api/cart')
    .then(response => {
        useCookieStore().initCartCount(response.totalQuantity);
    })
    .catch(error => {
        console.error(error);
    });

const props = defineProps({
    text: String,
});
</script>
<style scoped lang="scss">
@use '@/scss/variables' as vars;

.navs {
    background-color: vars.$blackColor;
    color: vars.$whiteColor;
    display: flex;
    flex-direction: column-reverse;

    padding: 0.4rem 0 0.2rem 0;

    gap: 0.8rem;
    .marquee {
        overflow: hidden;
        position: relative;
        white-space: nowrap;
        .marquee-content {
            display: inline-block;
            padding-left: 100%;
            animation: marquee 15s linear infinite;
        }
    }

    .cart,
    .favoris,
    .contact,
    .button {
        cursor: pointer;
        font-size: 0.8em;
    }
    .right {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
    }
}

@keyframes marquee {
    0% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(-100%);
    }
}
@media screen and (min-width: vars.$mediumBreakpoint) {
    .navs {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 0.4rem 1rem 0.4rem 1rem;
        .marquee {
            flex-grow: 1;
            white-space: nowrap;
            overflow: hidden;
        }
        .right {
            width: fit-content;
            gap: 1rem;
        }
    }
}

.nbr-count {
    top: -8px;
    right: -8px;
    background-color: #d60b52;
    font-size: 12px;
    position: absolute;
    font-weight: 700;
    color: rgb(255, 255, 255);
    pointer-events: none;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
}
</style>
